import HowToPlayListItem from "app/ui/HowToPlayListItem";
import TypoWord from "app/ui/TypoWord";
import cn from "app/utils/classnames";

export default function getBuzzInInstructions(): React.ReactNode {
  return (
    <ul className={cn("list-disc", "pl-4", "flex flex-col gap-2")}>
      <HowToPlayListItem key={0}>
        You'll hear a word's <TypoWord word="definition" />.
      </HowToPlayListItem>
      <HowToPlayListItem key={1}>
        Buzz-in as soon as you <TypoWord word="guess" /> what the word is.{" "}
        <TypoWord word="Spelling" /> counts!
      </HowToPlayListItem>
    </ul>
  );
}
